import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  s3Host: '',
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setS3Host: (state, action: PayloadAction<string>) => {
      state.s3Host = action.payload;
    },
  },
});

export const appReducer = appSlice.reducer;
export const appActions = appSlice.actions;
